"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextTypes = void 0;
var TextTypes;
exports.TextTypes = TextTypes;
(function (TextTypes) {
  TextTypes["Big"] = "big";
  TextTypes["Bold"] = "bold";
  TextTypes["Default"] = "default";
})(TextTypes || (exports.TextTypes = TextTypes = {}));